import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import emailjs from '@emailjs/browser';
import { useTranslation } from "react-i18next";
export const Contact = () => {
  const [t] = useTranslation("global");
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Ok')
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }
  const validateInputs = ({firstName,lastName,email,phone,message}) =>{
    if(firstName && lastName && email && phone && message){return true} else{return false}
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(status.succes)
    setButtonText(t("contact.sending"));

    if(!validateInputs(formDetails)){
      setStatus({ succes: false, message: 'Ingrese todos los campos'})
      setButtonText(t("contact.submit"))
      return
    };

    var templateParams = {
      to_name: 'Cristian',
      from_name: formDetails.firstName +' ' + formDetails.lastName,
      message: formDetails.message + ', Phone: '+ formDetails.phone  +' , Email: ' + formDetails.email,
      reply_to: 'Phone: '+ formDetails.phone  +' ,Email: ' + formDetails.email,
  };
   
    emailjs.send('service_bf5kedm', 'template_m5p6xod', templateParams,'YPzSGLaijW31yOMzg')
      .then(function(response) {
        setStatus({ succes: true, message: 'Mensaje enviado'});
        setButtonText(t("contact.sended"))
        setFormDetails(formInitialDetails);
      }, function(error) {
        setButtonText("Error")
        setStatus({ succes: false, message: 'Error'});
      });
 
     /*   */
/* 
    let response = await fetch("http://localhost:5000/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    });
    setButtonText("Enviado");
    let result = await response.json();
    setFormDetails(formInitialDetails);
    if (result.code == 200) {
      setStatus({ succes: true, message: 'Mensaje enviado'});
    } else {
      setStatus({ succes: false, message: 'Error'});
    } */
  };

  return (
    <section className="contact" id="contacto">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>{t("contact.title")}</h2>
{/*                 <form onSubmit={handleSubmit}>
                <fieldset disabled={status.success}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.firstName} placeholder={t("contact.name")} onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.lastName} placeholder={t("contact.lastname")} onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={formDetails.email} placeholder={t("contact.email")} onChange={(e) => onFormUpdate('email', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={formDetails.phone} placeholder={t("contact.phone")} onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" value={formDetails.message} placeholder={t("contact.message")} onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                      <button type="submit" className={status.succes ? "sucess-btn" : ""}><span>{buttonText}</span></button>
                    </Col>

                  </Row>
                  </fieldset>
                </form> */}
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
